import React, { Fragment } from 'react';
import styled from 'styled-components';
import { theme } from '../../theme';
import { Cell } from './Cell';
import { TableType } from './types';
import {
  getCellContent,
  getCellHref,
  getCellOnClick,
  formatCells,
  sortColumnData,
} from './utils';

export type CompactTableProps = TableType;

const Row = styled.div`
  border-bottom: 1px solid ${theme.colors.neutrals.solidGrays[6]};
  display: grid;
  grid-template-columns: auto auto auto;
  padding: ${theme.spacings[3].rem} 0 ${theme.spacings[2].rem};

  &:first-of-type {
    border-top: 1px solid ${theme.colors.neutrals.solidGrays[6]};
  }
`;

const StyledCell = styled(Cell)`
  display: inline-block;
  padding-bottom: ${theme.spacings[1].rem};

  &:nth-child(3n) {
    text-align: right;
  }
`;

export const CompactTable: React.FC<CompactTableProps> = ({
  columnData,
  data,
}) => {
  const sortedColumnData = sortColumnData(columnData);

  return (
    <>
      {data.map((row, j) => (
        <Row key={j}>
          {formatCells(sortedColumnData, row).map((cell, i) => (
            <Fragment key={i}>
              {i === 1 && <span></span>}
              <StyledCell
                content={getCellContent(cell)}
                href={getCellHref(cell)}
                onClick={getCellOnClick(cell)}
                isBold={sortedColumnData[i].isBold}
                type={sortedColumnData[i].type}
              />
            </Fragment>
          ))}
        </Row>
      ))}
    </>
  );
};
